(function () {
    window.KocotAnimations = window.KocotAnimations || {};

    window.KocotAnimations.initImageParallaxAnimations = function () {
        var images = document.querySelectorAll('[data-anim="img-paralax"]');
        var ticking = false;
        var parallaxRange = 80;

        if (!images.length) {
            return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        function clamp(value, min, max) {
            return Math.min(Math.max(value, min), max);
        }

        function update() {
            var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

            images.forEach(function (image) {
                var rect = image.getBoundingClientRect();
                var progress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
                var offset = (0.5 - progress) * parallaxRange;

                image.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0)';
            });

            ticking = false;
        }

        function requestUpdate() {
            if (ticking) {
                return;
            }

            ticking = true;
            window.requestAnimationFrame(update);
        }

        update();
        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate);

        if (window.lenis && typeof window.lenis.on === 'function') {
            window.lenis.on('scroll', requestUpdate);
        }
    };
})();
